

export const tipoGastro = (dataSemiologia) => {
  const { sintomas } = dataSemiologia;

  if( sintomas && sintomas.length > 0 ) {
    return ` con sintomas ( ${sintomas.map( item => item.text ).join(', ')} )`;
  }

  return'';
}